module.exports = __webpack_public_path__ + "img/purple_dots.fd02bb7c.svg";